import React from 'react';
import {Table} from 'antd';
import { useHistory } from 'react-router-dom';
const columns = [
    {
        title: "USER NAME",
        dataIndex: "user_name",
        key: "user_name",
        width: "10%"
    },
    {
        title: "LAST NAME",
        dataIndex: "last_name",
        key: "last_name",
        width: "25%"
    },
    {
        title: "FIRST NAME",
        dataIndex: "first_name",
        key: "first_name",
        width: "25%"
    },
    {
        title: "MIDDLE NAME",
        dataIndex: "middle_name",
        key: "middle_name",
        width: "20%"
    },
    {
        title: "ROLE",
        dataIndex: "role_name",
        key: "role",
        width: "10%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "10%"
    },
];

function SearchUSerTable(props) {
    const history = useHistory();
    const { data, pageSize } = props;
    return(
        <div>
            <Table
                // style={ {textTransform: "uppercase"} }
                dataSource = {data}
                columns={columns}
                bordered
                pagination={{ pageSize }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => history.push('/user/update_user', record)
                    };
                }}
            />
        </div>
    )
}

export default SearchUSerTable;